/** INIT locales and i18n translations

  Will load from ../site/language/en.js and so on

* @Author: Tom Voorneveld <root>
* @Date:   2016-10-18T22:00:06+02:00
* @Email:  tom@lorinthe.com
* @Project: Qrespi
 * @Last modified by:   tom
 * @Last modified time: 2018-11-13T23:19:30+01:00
* @License: Copyright Lorinthe BV, The Netherlands. All rights reserved
*/

import Vue from 'vue'

/** LANGUAGES / LOCALES */
// https://kazupon.github.io/vue-i18n/
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// Load files from lang folder
const loadLocales = [
  { isocode: 'en', language: 'English' },
  { isocode: 'nl', language: 'Nederlands' }
]
const messages = {}

loadLocales.forEach(function (lang) {
  // loading files such as en.coffee and nl.coffee
  // reason we use .coffee as format is that we then can use spell-check on source.coffee
  const langObj = require('../lang/' + lang.isocode + '.js')
  messages[lang.isocode] = langObj
})

// set browser language Footer component can change the language
const lang = Vue.config.lang || window.navigator.userLanguage || window.navigator.language || 'en'
Vue.config.lang = lang.substr(0, 2) // "en-US" >> "en"

const i18n = new VueI18n({
  locale: Vue.config.lang, // set locale
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages // set locale messages
})

export default i18n
